var map = {
	"./favicon.png": "6d55",
	"./fitshow.png": "16f0",
	"./hitgo.png": "40ad",
	"./kinomap.png": "bc47",
	"./logo-2x.png": "97d3",
	"./logo-colorfull-2x.png": "0b3d",
	"./logo-colorfull.png": "06b7",
	"./logo-dark.png": "6996",
	"./logo.png": "a4ef",
	"./ota_tools.png": "2ac5",
	"./sflogo-dark.png": "10c6",
	"./zwift.png": "ec22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "818c";